import { useRouter } from "#/hocs/withRouter";
import useScrollBehaviours from "#/hooks/useScrollBehaviours";
import useWindowDimensions from "#/hooks/useWindowDimensions";
import {
  Asset,
  Icon,
  Layout,
  // NotificationBadge,
  Button,
  Paragraph,
} from "@sicredi/react";
import styles from "./styles.module.scss";

import Sidebar from "../Sidebar/Sidebar";

import { commonMenus, handlerNotRouters } from "#/utils/headerRoutes";

import { PAGE } from "#/constants";
import { useSystemicCategories } from "#/hooks/useCategories";
import { returnOnScrollBehaviour } from "#/utils/formatters";
import ModalLocationConfiguration from "../Modal/ModalLocationConfiguration";
import { FixedCategories } from "./MenuCategories";
import SearchInput from "./SearchInput";
import { handlerDatalayer } from "#/utils/handlerdatalayer";
import Auth from "../Auth/Auth";
import { getWidth } from "#/utils/windowDimensionUtils";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}
export default function HeaderContainer() {
  const { width, height } = useWindowDimensions();
  const { scrollY } = useScrollBehaviours();

  const { handleGoNextPage } = useRouter();
  const categories = useSystemicCategories();

  const menus = [...commonMenus];

  const tabs = [
    {
      id: 0,
      label: "Shopping",
      routerOrhref: "https://shopping.sicredi.com.br/",
    },
    {
      id: 1,
      label: "Parcerias e Descontos",
      routerOrhref: "",
    },
    {
      id: 2,
      label: "Viagens",
      routerOrhref: "https://viagens.app.sicredi.com.br/",
    },
    {
      id: 3,
      label: "Imóveis e Veículos",
      routerOrhref: "https://imoveiseveiculos.app.sicredi.com.br/",
    },
  ];

  function handlerRouters(
    router: string,
    isRouter: boolean,
    label: string
  ): void {
    if (isRouter) {
      handlerDatalayer({
        dataLayer: {
          event: "sicredi_parceiros",
          nome_do_evento: "cabecalho",
          acao: label,
        },
      });
      handleGoNextPage(router);
      return;
    }

    handlerNotRouters(router);
  }

  return (
    <div data-testid="header">
      <div className={styles["top-header"]} data-testid="header-tabs">
        <div className={styles.container}>
          <Paragraph
            size="x-small"
            style={{ fontStyle: "italic", margin: "auto" }}
          >
            Parcerias e Descontos do Sicredi
          </Paragraph>
          <div className={styles["tab"]}>
            {tabs.map((elem: any) => (
              <button
                data-testid={`tab-button${elem.id}`}
                key={elem.id}
                className={styles["tablinks"]}
                onClick={() =>
                  handlerRouters(elem.routerOrhref, false, elem.label)
                }
                id={`default-${elem.id}`}
              >
                {elem.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      {getWidth(width, 1024) ? (
        <div className={styles["header-actions"]} data-testid="header-desktop">
          <div
            id="container-header-actions"
            data-testid="container-header-actions"
            className={styles.container}
            style={returnOnScrollBehaviour(scrollY)}
          >
            <div className={styles["main-header"]}>
              <div className={styles["margin-left"]} />
              <Asset
                data-testid="asset-desktop"
                name="sicredi-logo"
                width={150}
                height={45}
                style={{ cursor: "pointer" }}
                onClick={() => handleGoNextPage(PAGE.ROOT())}
              />
              <SearchInput />
              <div style={{ marginLeft: "auto", paddingRight: "20px" }}>
                <Paragraph
                  className={styles["location-area"]}
                  style={{ color: "#3FA111" }}
                  size="small"
                >
                  <img
                    src="/icons/pin-map.svg"
                    width={16}
                    height={16}
                    alt="localização"
                  />{" "}
                  Ofertas para região <ModalLocationConfiguration />
                </Paragraph>
              </div>
              <Auth />
              <Button
                data-testid="button-orders"
                style={{ marginLeft: "12px", marginRight: "30px" }}
                onClick={() => handleGoNextPage(PAGE.MY_ORDERS())}
              >
                <img src="/icons/package.svg" alt="meus-pedidos" />{" "}
                <span style={{ marginLeft: "8px" }}>Meus Pedidos </span>
              </Button>
              <Button
                data-testid="button-cart"
                style={{ marginLeft: "12px", marginRight: "30px" }}
                onClick={() => handleGoNextPage(PAGE.CART())}
              >
                <img src="/icons/cart.svg" alt="carrinho" />
              </Button>

              <div className={styles["margin-right"]} />
            </div>
            <div className={styles["header-menus"]}>
              <div className={styles.dropdown}>
                <nav
                  data-testid="nav-categories"
                  className={`${styles["outlined-button"]} ${styles.green}`}
                  // onClick={() => handleGoNextPage(PAGE.CATEGORIES())}
                >
                  <Icon height={24} name="menu" />
                  Conheça também
                  <Icon name="chevron-down" />
                </nav>
                <div
                  className={styles["dropdown-content"]}
                  style={{ maxHeight: height - 223 }}
                >
                  <FixedCategories />
                </div>
              </div>
              {menus.map((elem) => (
                <button
                  data-testid={`menus-desktop${elem.id}`}
                  style={{
                    minWidth: "50px",
                    /* color: elem.id === 2 ? "#3FA111" : "",
                    fontWeight: elem.id === 2 ? "700" : "", */
                  }}
                  key={elem.id}
                  className={`${styles["outlined-button"]} ${styles.grey}`}
                  onClick={() =>
                    handlerRouters(elem.routerOrhref, elem.route, elem.label)
                  }
                >
                  {elem.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className={styles["header-actions"]} data-testid="header-mobile">
          <div
            id="container-header-actions-mobile"
            className={styles.container}
            style={returnOnScrollBehaviour(scrollY)}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "12px 24px 10px 24px",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "42%",
                }}
              >
                <Sidebar categories={categories} />
                <Asset
                  data-testid="asset-mobile"
                  style={{
                    margin: "0 10px 0 -15px",
                    cursor: "pointer",
                    padding: "0",
                  }}
                  name="sicredi-logo"
                  width={69}
                  height={15}
                  onClick={() => handleGoNextPage(PAGE.ROOT())}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  justifyItems: "flex-end",
                  width: "46%",
                }}
              >
                <Auth />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "0 20px",
              }}
            >
              <Paragraph
                className={styles["location-area"]}
                style={{
                  color: "#3FA111",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                }}
              >
                <img
                  src="/icons/pin-map.svg"
                  width={16}
                  height={16}
                  alt="localização"
                  style={{
                    paddingTop: "2px",
                    marginRight: "3px",
                  }}
                />
                Ofertas para região <ModalLocationConfiguration />
              </Paragraph>
              <div>
                <Button
                  data-testid="button-orders"
                  style={{ marginLeft: "12px", marginRight: "10px" }}
                  onClick={() => handleGoNextPage(PAGE.MY_ORDERS())}
                >
                  <img src="/icons/package.svg" alt="meus-pedidos" />
                </Button>
                <Button
                  data-testid="button-cart"
                  style={{ marginLeft: "auto" }}
                  onClick={() => handleGoNextPage(PAGE.CART())}
                >
                  <img src="/icons/cart.svg" alt="carrinho" />
                </Button>
              </div>
            </div>
            <Layout.Wrapper
              style={{
                margin: "16px 0 8px 0",
              }}
            >
              <SearchInput />
            </Layout.Wrapper>
          </div>
        </div>
      )}
    </div>
  );
}
